var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{staticClass:"state_modal",attrs:{"width":"550","value":_vm.value},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-card',[_c('v-card-title'),_c('v-card-text',[(_vm.resetFlag)?_c(_vm.prefix.component,_vm._b({tag:"component"},'component',_vm.prefix.props,false)):_vm._e()],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }